import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LinkArr } from "../../../common/svg/AllSvg";
import { useNavigate, useParams } from "react-router-dom";

const AboutProject = ({ data }: any) => {
    const { t } = useTranslation('common');
    const [projects, setProjects] = useState<any[]>([]);
    const [select, setSelect] = useState<number>(0);
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        if (data?.section_two?.data?.length > 0) {
            let arr: any[] = [];
            data?.section_two?.data.forEach((el: any) => {
                arr.push(el?.tab_title)
            });

            setProjects(arr)
        }
    }, [data])

    return (
        <div className="w-full h-full pt-[30px] lg:pt-[70px] flex flex-col gap-[30px] container">
            <div className="w-full flex items-center justify-center">
                <div className="w-fit rounded-[50px] bg-[#F6F6F6] dark:bg-bgDark shadow-[0px_1.953px_3.906px_-1.953px_rgba(24,39,75,0.12),0px_3.906px_3.906px_-1.953px_rgba(24,39,75,0.08)] h-[42px] sm:h-[45px] xlx:h-[50px] px-[7px] py-[5px] flex items-center gap-[2px] relative z-[1]">
                    {Array?.isArray(projects) && projects.map((item: any, index: number) => (
                        <button className={`${select === index ? "bg-primary focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e] text-white" : "text-blackDull dark:text-textBlackDull focus:bg-[#dddddd75] hover:bg-[#dddddd75] dark:focus:bg-[#dddddd21] dark:hover:bg-[#dddddd21]"} flex items-center justify-center px-[15px] xs:px-[20px] xlx:px-[24px] text-sm font-semibold h-full rounded-full uppercase leading-[19px]`} key={index} onClick={() => setSelect(index)}>{item}</button>
                    ))}
                </div>
            </div>

            {select === 0 ?
                <div className="flex items-center msm:justify-between gap-[30px] msm:flex-row flex-col">
                    <div className="flex flex-col gap-[20px] xlx:gap-[30px] items-start justify-start">
                        <div className="flex flex-col gap-[5px]">
                            <h5 className="text-primary font-bold uppercase">{data?.section_two?.data?.[select]?.tab_title}</h5>
                            <h1 className="text-primaryText dark:text-white font-bold max-w-[490px]">{data?.section_two?.data?.[select]?.title}</h1>
                        </div>

                        <h5 className="*:text-blackDull *:dark:text-textBlackDull *:font-medium *:text-base max-w-[470px] *:text-justify text-blackDull dark:text-textBlackDull font-medium text-base text-justify" dangerouslySetInnerHTML={{ __html: data?.section_two?.data?.[select]?.description }} />

                        <button className="rounded-[10px] shadow-[0px_6px_12px_-6px_rgba(24,39,75,0.12),0px_8px_24px_-4px_rgba(24,39,75,0.08)] border border-primaryText dark:border-white flex items-center justify-center gap-[10px] px-[14px] xlx:px-[19px] h-[35px] xlx:h-[40px] text-primaryText dark:text-white text-sm font-extrabold w-fit uppercase focus:shadow-[0_0_0_2px_#1a1f365e] hover:shadow-[0_0_0_2px_#1a1f365e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/corporate/pages/project-route`) : navigate(`/corporate/pages/project-route`)}>
                            {t("corporate.banner.view_more")}
                            <div className="pb-[2.5px]">
                                <LinkArr className="fill-primaryText dark:fill-white min-w-[9px] xlx:min-w-[10px] w-[9px] xlx:w-[10px] h-[10px] xlx:h-[11px]" />
                            </div>
                        </button>
                    </div>

                    <div className="msm:mt-[-325px] xl:mt-[-350px] relative">
                        <div className="project-route-aOIIF">
                            <div className="project-route-aOIIC">
                                <div className="project-route-aOIIG">
                                    <div className="rounded-full bg-white w-[20px] h-[20px] min-w-[20px] flex items-center justify-center">
                                        <div className="project-route-aOIIh"></div>
                                    </div>
                                    <h5>Functional</h5>
                                </div>

                                <div className="project-route-aOIIG">
                                    <div className="rounded-full bg-white w-[20px] h-[20px] min-w-[20px] flex items-center justify-center">
                                        <div className="project-route-aOIIl"></div>
                                    </div>
                                    <h5>Opening Soon</h5>
                                </div>

                                <div className="project-route-aOIIG">
                                    <div className="rounded-full bg-white w-[20px] h-[20px] min-w-[20px] flex items-center justify-center">
                                        <div className="project-route-aOIII"></div>
                                    </div>
                                    <h5>Under Progress</h5>
                                </div>
                            </div>
                        </div>
                        <img src={data?.section_two?.data?.[select]?.tab_image?.file} alt={data?.section_two?.data?.[select]?.tab_title} className="w-fit" />
                    </div>
                </div>
                :
                <div className="w-full relative">
                    <img src={require("../../../../assets/images/pattern.png")} alt="pattern" className="absolute top-[-200px] left-[-312px] project-funding-pattern" />

                    <div className="w-full flex flex-col gap-[30px] xlx:gap-[50px] relative z-[1] h-full items-center justify-center">
                        <div className="w-full flex md:items-center md:justify-between gap-[15px] md:flex-row flex-col">
                            <div className="flex flex-col gap-[5px]">
                                <h5 className="text-primary font-bold uppercase">{data?.section_two?.data?.[select]?.tab_title}</h5>
                                <h1 className="text-primaryText dark:text-white font-bold max-w-[490px]">{data?.section_two?.data?.[select]?.title}</h1>
                            </div>

                            <div className="flex flex-col *:text-blackDull *:dark:text-textBlackDull *:font-medium text-blackDull dark:text-textBlackDull font-medium max-w-[545px] *:text-justify" dangerouslySetInnerHTML={{ __html: data?.section_two?.data?.[select]?.description }} />
                        </div>

                        <img src={data?.section_two?.data?.[select]?.tab_image?.file} alt="project-funding" className="w-fit" />
                    </div>
                </div>
            }
        </div>
    );
};

export default AboutProject;